@if (isEnabled) {
<div class="bottom-panel">
  <div class="dw-header">
    <div class="dw-title">
      <div class="dw-title__icon" style="background: var(--teal-bg)">
        <mat-icon style="color: var(--teal-dark)">calendar_today</mat-icon>
      </div>
      {{'GUI.dashboard.labels.upcoming appointments' | translate}}
      <app-scope-chip scope="clinic"></app-scope-chip>
    </div>
    <div class="dw-header__right">
      <a
        class="dw-link"
        role="button"
        tabindex="0"
        (click)="openCalendar()"
        (keyup.enter)="openCalendar()"
        (keyup.space)="openCalendar()"
      >
        {{'GUI.dashboard.labels.view calendar' | translate}}
      </a>
    </div>
  </div>
  <div class="appt-list">
    @if (loading || loadingAppts()) { @for (_ of [1,2,3]; track $index) {
    <div class="skel skel--row"></div>
    } } @else { @for (a of appointments(); track a.name) {
    <div class="appt-row">
      <div class="appt-time">
        <div class="appt-time__day">{{ a.day }}</div>
        <div class="appt-time__num">{{ a.date }}</div>
      </div>
      <div class="appt-info">
        <div class="appt-name">{{ a.name }}</div>
        <div class="appt-type">{{ a.type }}</div>
      </div>
      <div class="appt-hour">{{ a.time }}</div>
    </div>
    } @empty {
    <span class="banner-empty">
      {{'GUI.dashboard.labels.no appointments available' | translate}}
    </span>
    } }
  </div>
</div>
} @else {
<div class="bottom-panel">
  <div class="dw-header">
    <div class="dw-title">
      <div class="dw-title__icon" style="background: var(--teal-bg)">
        <mat-icon style="color: var(--teal-dark)">calendar_today</mat-icon>
      </div>
      {{'GUI.dashboard.labels.upcoming appointments' | translate}}
      <app-scope-chip scope="clinic"></app-scope-chip>
    </div>
    <label class="access-toggle">
      <input
        type="checkbox"
        [checked]="isEnabled"
        (change)="toggleAccess.emit($any($event.target).checked)"
      />
      <span class="access-toggle__track"></span>
      <span class="access-toggle__thumb"></span>
    </label>
  </div>
  <div class="access-locked">
    <div class="access-locked__icon">
      <mat-icon>lock</mat-icon>
    </div>
    <div class="access-locked__text">
      Calendar access is disabled.<br />Contact your administrator to enable it.
    </div>
  </div>
</div>
}
